import Layout from "components/layout/Layout";
import { useEffect, useState } from "react";
import { Collapse } from "react-collapse";
import { useDispatch, useSelector } from "react-redux";
import { getFaqs } from "redux/slices/aboutSlice";

// const FAQ_ARR = [
//   {
//     title: "Can AI content writing replace human writers?",
//     id: 1,
//     content:
//       "AI content writing works by using machine learning algorithms to analyze vast amounts of data, including text, images, and videos, to generate unique and engaging content. The software learns from previous content and can mimic the style and tone of human writers.",
//   },
//   {
//     title: "How does AI content writing work?",
//     id: 2,
//     content:
//       "AI content writing works by using machine learning algorithms to analyze vast amounts of data, including text, images, and videos, to generate unique and engaging content. The software learns from previous content and can mimic the style and tone of human writers.",
//   },
//   {
//     title: "What is AI content writing?",
//     id: 3,
//     content:
//       "AI content writing works by using machine learning algorithms to analyze vast amounts of data, including text, images, and videos, to generate unique and engaging content. The software learns from previous content and can mimic the style and tone of human writers.",
//   },
//   {
//     title: "What are the benefits of using AI content writing?",
//     id: 4,
//     content:
//       "AI content writing works by using machine learning algorithms to analyze vast amounts of data, including text, images, and videos, to generate unique and engaging content. The software learns from previous content and can mimic the style and tone of human writers.",
//   },
//   {
//     title: "Is AI content writing ethical?",
//     id: 5,
//     content:
//       "AI content writing works by using machine learning algorithms to analyze vast amounts of data, including text, images, and videos, to generate unique and engaging content. The software learns from previous content and can mimic the style and tone of human writers.",
//   },
//   {
//     title: "How much does AI content writing cost?",
//     id: 6,
//     content:
//       "AI content writing works by using machine learning algorithms to analyze vast amounts of data, including text, images, and videos, to generate unique and engaging content. The software learns from previous content and can mimic the style and tone of human writers.",
//   },
//   {
//     title: "How accurate is the content generated by AI software?",
//     id: 7,
//     content:
//       "AI content writing works by using machine learning algorithms to analyze vast amounts of data, including text, images, and videos, to generate unique and engaging content. The software learns from previous content and can mimic the style and tone of human writers.",
//   },
// ];

export default function Faq() {
  const dispatch = useDispatch();
  const faqs = useSelector((state) => state?.about?.faqs?.results)
  useEffect(() => {
    dispatch(getFaqs());
   
  }, []);
  const [isActive, setIsActive] = useState({
    status: false,
    id: 1,
  });

  const handleToggle = (id) => {
    if (isActive.id === id) {
      setIsActive({
        status: false,
      });
    } else {
      setIsActive({
        status: true,
        id,
      });
    }
  };
  return (
    <>
      <Layout
        headerStyle={1}
        footerStyle={1}
        breadcrumbTitle={
          <>
            Ask <span>Question</span>
          </>
        }
      >
        <section className="faq-area pb-150">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="faq-wrap">
                  <div className="accordion">
                    {faqs?.map((faq) => (
                      <div
                        className={
                          isActive.id === faq?.id
                            ? "accordion-item active"
                            : "accordion-item"
                        }
                        id={faq?.id}
                      >
                        <h2 className="accordion-header">
                          <button
                            className={
                              isActive.id === faq?.id
                                ? "accordion-button"
                                : "accordion-button collapsed"
                            }
                            type="button"
                            onClick={() => handleToggle(faq?.id)}
                          >
                            {faq?.quote}
                          </button>
                        </h2>
                        <Collapse isOpened={isActive.id === faq?.id}>
                          <div
                            className={
                              isActive.id === faq?.id
                                ? "accordion-collapse collapse show"
                                : "accordion-collapse collapse"
                            }
                          >
                            <div className="accordion-body">
                              <p>{faq?.answer}</p>
                            </div>
                          </div>
                        </Collapse>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
}
